<his-dynamic-container-inner
	[dynamicFieldConfig]="dynamicFieldConfig"
	[form]="form"
	[valueGroup]="valueGroup">
</his-dynamic-container-inner>